export const styles = {
    input: {
        fontWeight: "bold",
        color: "black",
        // The mobile field is scaled down to avoid the iOS input zoom, so this height is
        // pre-scale: 55px renders as ~48px. Check @packages/ui/src/components/forms/input/Input.styles for more information
        h: ["55px", 10.4],
        _readOnly: {
            bg: "gray.50",
            cursor: "not-allowed",
            borderColor: "gray.800",
        },
        _selected: {
            outline: "none",
        },
        ['[role="group"][data-success="true"] &']: {
            borderColor: "green.900",
        },
    },
    label: {
        fontWeight: "bold",
        fontSize: ["mobileBodyB2", "desktopBodyB2"],
    },
    icon: {
        success: {
            color: "green.900",
        },
        invalid: {
            color: "red.500",
        },
    },
};
